import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment } from '@angular/router';
import { AppState } from '@app/reducers';
import { isLoggedIn } from '@modules/others';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CanLoadAuthenticationGuard implements CanLoad {
    constructor(private router: Router, private store: Store<AppState>) { }
    canLoad(route: Route, segments: UrlSegment[]): boolean | Observable<boolean> | Promise<boolean> {
        return this.store.pipe(take(1), select(isLoggedIn),
            tap(loggedIn => {
                if (!loggedIn) {
                    this.router.navigateByUrl('/login');
                    return false;
                }
                else {
                    return true;
                }
            }),
        );
    }
}